export enum InventaireStatut {
    Nouveau,
    EnCoursDeTraitement,
    Traite,
    AttenteRetourClient,
    AttenteRetourAgent,
    Litige,
    AFacturer,
    AttenteRetourPC
}

export function TraitementInventaireStatut_ToText(input: InventaireStatut) {
    switch (input) {
        case InventaireStatut.Nouveau:
            return 'Nouveau'
        case InventaireStatut.EnCoursDeTraitement:
            return 'En cours de traitement'
        case InventaireStatut.Traite:
            return 'Traité'
        case InventaireStatut.AttenteRetourClient:
            return 'Attente Retour Client'
        case InventaireStatut.AttenteRetourAgent:
            return 'Attente Retour Agent'
        case InventaireStatut.Litige:
            return 'Litige'
        case InventaireStatut.AFacturer:
            return 'A Facturer'
        case InventaireStatut.AttenteRetourPC:
            return 'Attente retour PC'
    }
}
